export enum OvertimeFrequencyEnum {
  Never = 0,
  Seldom = 1,
  Frequent = 2
}